import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "filtros-secundarios" }
const _hoisted_3 = { class: "filtro-grupo" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "filtro-grupo" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "loading"
}
const _hoisted_8 = {
  key: 1,
  class: "mensaje-vacio"
}
const _hoisted_9 = {
  key: 2,
  class: "cards-grid"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "card-header-row" }
const _hoisted_12 = { class: "card-titulo" }
const _hoisted_13 = {
  key: 0,
  class: "card-creado"
}
const _hoisted_14 = { class: "card-meta" }
const _hoisted_15 = {
  key: 0,
  class: "card-obs"
}
const _hoisted_16 = { class: "progreso-wrapper" }
const _hoisted_17 = { class: "fase-label" }
const _hoisted_18 = {
  key: 0,
  class: "card-acciones"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["disabled", "title", "onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["disabled", "title", "onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["disabled", "onClick"]

import { ref, computed, onMounted } from 'vue'

import { useRouter, useRoute } from 'vue-router'
import { useGestionProcesos } from '@/store/GestionProcesoAutoevaluacion'
import { useGestionVersiones } from '@/store/GestionVersiones'
import { useGestionProgramas } from '@/store/GestionPrograma'
import { useGestionIndicadorEvaluadores } from '@/store/GestionIndicadorEvaluadores'
import { useGestionIndicadores } from '@/store/GestionIndicadores'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import useAutenticar from '@/store/IngresoAutenticar'
import type { EstadoProceso, Proceso } from '@/interfaces/ProcesoAutoevaluacion'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import AdjuntarInformesModal from '@/components/AdjuntarInformesModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProcesoAutoevaluacionUsuarioView',
  emits: ['cambiar-modo'],
  setup(__props, { emit: __emit }) {

/**
 * Los procesos en los que participa el usuario actual.
 *
 * Filtra por las asignaciones propias (ver `useAsignacionActual`).
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/mis-procesos` (ProcesoAutoevaluacionUsuario) — permiso `procesos.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const emit = __emit
const router = useRouter()
const route = useRoute()
const authStore = useAutenticar()
const procesosStore = useGestionProcesos()
const versionesStore = useGestionVersiones()
const programasStore = useGestionProgramas()
const evaluadoresStore = useGestionIndicadorEvaluadores()
const indicadoresStore = useGestionIndicadores()
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()

const cargando = ref(false)
const cardAbierta = ref<number | null>(null)
const filtroEstado = ref('')
const busqueda = ref('')
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')
const avanzandoId = ref<number | null>(null)
const ocultarFinalizados = ref(true)
const adjuntarVisible     = ref(false)
const adjuntarIdEjecucion = ref<number | null>(null)
const adjuntarPeriodo     = ref<string | null>(null)

const fases = [
  { label: 'Preparación', value: 'preparacion' },
  { label: 'Ejecución',   value: 'ejecucion' },
  { label: 'Evaluación',  value: 'evaluacion' },
  { label: 'Informe',     value: 'informe' },
  { label: 'Finalizado',  value: 'finalizado' }
]

const ordenFases: Record<string, number> = {
  preparacion: 0, ejecucion: 1, evaluacion: 2, informe: 3, finalizado: 4
}

const opcionesEstado = [
  { label: 'Preparación', value: 'preparacion' },
  { label: 'Ejecución', value: 'ejecucion' },
  { label: 'Evaluación', value: 'evaluacion' },
  { label: 'Informe', value: 'informe' },
  { label: 'Finalizado', value: 'finalizado' }
]

function calcularPeriodoActual(): string {
  const now = new Date()
  const year = now.getFullYear()
  return (now.getMonth() + 1) <= 6 ? `${year}-1` : `${year}-2`
}

function esProcesoHistorico(p: Proceso): boolean {
  if (p.periodo !== calcularPeriodoActual()) return true
  const idsIndicadores = new Set(
    indicadoresStore.indicadores
      .filter(i => i.id_version === p.id_version && i.id_indicador != null)
      .map(i => i.id_indicador as number)
  )
  if (idsIndicadores.size === 0) return false
  return !indicadorInstrumentoStore.relaciones.some(r => idsIndicadores.has(r.id_indicador))
}

// IDs de procesos donde el usuario tiene cualquier asignación
const ejecucionesDelUsuario = computed(() => {
  const ids = new Set<number>()
  for (const a of evaluadoresStore.misAsignaciones) {
    if (a.id_ejecucion != null) ids.add(a.id_ejecucion)
  }
  return ids
})

// IDs de procesos con asignación explícita de director (id_indicador: null)
const ejecucionesDirector = computed(() => {
  const ids = new Set<number>()
  for (const a of evaluadoresStore.misAsignaciones) {
    if (a.id_indicador == null && a.id_ejecucion != null) ids.add(a.id_ejecucion)
  }
  return ids
})

// true si el usuario solo tiene indicadores específicos asignados, no es director
function esEspecifica(proceso: { id?: number; lideresFactor?: { id_usuario: number }[] }): boolean {
  const idUsuario = authStore.usuarioActual?.id
  if (!idUsuario) return true
  // Administradores ven siempre todo
  if (authStore.esAdmin || authStore.tienePermiso('procesos.crear')) return false
  // El usuario aparece como LiderFactor del proceso → es director
  if (proceso.lideresFactor?.some(lf => lf.id_usuario === idUsuario)) return false
  // Asignación explícita de director (id_indicador: null)
  if (proceso.id != null && ejecucionesDirector.value.has(proceso.id)) return false
  return true
}

const procesosFiltrados = computed(() => {
  let base = procesosStore.procesos.filter(p => p.id != null && ejecucionesDelUsuario.value.has(p.id!))
  if (filtroEstado.value) base = base.filter(p => p.estado === filtroEstado.value)
  if (ocultarFinalizados.value && filtroEstado.value !== 'finalizado') {
    base = base.filter(p => p.estado !== 'finalizado')
  }
  if (busqueda.value.trim()) {
    const t = busqueda.value.trim().toLowerCase()
    base = base.filter(p => p.periodo.toLowerCase().includes(t))
  }
  return base
})

function nombreVersion(idVersion: number): string {
  const v = versionesStore.versiones.find(v => v.id_version === idVersion)
  return v?.nombre ?? `Versión #${idVersion}`
}

function nombrePrograma(idPrograma?: number | null): string {
  if (!idPrograma) return 'Programa'
  const p = programasStore.programas.find(p => p.id_programa === idPrograma)
  return p?.nombre ?? `Programa #${idPrograma}`
}

function formatFecha(fecha: string): string {
  return new Date(fecha).toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' })
}

function pasoActivo(estadoActual: EstadoProceso | undefined, faseval: string) {
  return estadoActual === faseval
}

function pasoCompletado(estadoActual: EstadoProceso | undefined, idx: number) {
  const actual = ordenFases[estadoActual ?? ''] ?? -1
  return actual > idx
}

// El plan se deriva de la matriz F/D, disponible desde `informe`.
function puedeVerPlan(p: { estado?: EstadoProceso }) {
  return p.estado === 'informe' || p.estado === 'finalizado'
}

function puedeAsignarTareas(p: { estado?: EstadoProceso }) {
  return p.estado === 'ejecucion' || p.estado === 'evaluacion'
}

const siguienteEstado: Record<string, EstadoProceso> = {
  preparacion: 'ejecucion',
  ejecucion:   'evaluacion',
  evaluacion:  'informe',
  informe:     'finalizado',
}

function labelAvanzar(estado?: EstadoProceso): string {
  return estado === 'informe' ? 'Finalizar proceso' : 'Avanzar proceso'
}

async function avanzarProceso(p: Proceso) {
  if (!p.id || !p.estado || p.estado === 'finalizado' || avanzandoId.value !== null) return
  const siguiente = siguienteEstado[p.estado]
  if (!siguiente) return
  avanzandoId.value = p.id
  try {
    const result = await procesosStore.cambiarEstado(p.id, siguiente)
    if (result.ok) {
      mensajeTexto.value = 'Estado del proceso actualizado correctamente.'
      mensajeTipo.value = 'positivo'
    } else {
      mensajeTexto.value = 'No se pudo cambiar el estado del proceso.'
      mensajeTipo.value = 'error'
    }
    mensajeVisible.value = true
  } finally {
    avanzandoId.value = null
  }
}

function cambiarModo() {
  if (route.name === 'ProcesoAutoevaluacionUsuario') {
    router.push({ name: 'ProcesoAutoevaluacion' })
  } else {
    emit('cambiar-modo')
  }
}

function toggleCard(id: number) {
  cardAbierta.value = cardAbierta.value === id ? null : id
}

/**
 * La ejecución viaja en la query porque de ella sale el ÁREA: las fichas de
 * opinión ofrecen los correos ya usados con cada grupo de interés en esa área,
 * y sin la ejecución ese banco queda mudo. Evidencias la propaga a la ficha.
 */
function irAEvidencias(idVersion: number, idEjecucion?: number | null) {
  router.push({
    name: 'EvidenciasInstrumentos',
    params: { id_version: idVersion },
    ...(idEjecucion ? { query: { id_ejecucion: idEjecucion } } : {})
  })
}

function irACalificar(idVersion: number) {
  router.push({ name: 'ListaCalificar', params: { id_version: idVersion } })
}

function irAModelo(idEjecucion?: number) {
  router.push({ name: 'AvanceProceso', params: { id_ejecucion: idEjecucion ?? 0 } })
}

function irAComparativo(id?: number) {
  if (!id) return
  router.push({ name: 'ComparacionCalificaciones', params: { id_ejecucion: id } })
}

function irAResultados(id?: number) {
  if (!id) return
  router.push({ name: 'ResultadosAutoevaluacion', params: { id_ejecucion: id } })
}


function irAInforme(id?: number) {
  if (!id) return
  router.push({ name: 'InformeAutoevaluacion', params: { id_ejecucion: id } })
}

function irAPlanMejoramiento(id?: number) {
  if (!id) return
  router.push({ name: 'PlanMejoramiento', params: { id_ejecucion: id } })
}

function irAAsignarTareas(id?: number) {
  if (!id) return
  router.push({ name: 'AsignarTareasDirector', params: { id_ejecucion: id } })
}

function abrirAdjuntarInformes(p: Proceso) {
  if (!p.id) {
    mensajeTexto.value = 'No se pudo identificar la ejecución.'
    mensajeTipo.value = 'error'
    mensajeVisible.value = true
    return
  }
  adjuntarIdEjecucion.value = p.id
  adjuntarPeriodo.value = p.periodo ?? null
  adjuntarVisible.value = true
}

function alSubirInformes(cantidad: number) {
  mensajeTexto.value = cantidad === 1
    ? 'Archivo adjuntado correctamente.'
    : `${cantidad} archivos adjuntados correctamente.`
  mensajeTipo.value = 'positivo'
  mensajeVisible.value = true
}

onMounted(async () => {
  cargando.value = true
  const idUsuario = authStore.usuarioActual?.id
  await Promise.all([
    procesosStore.cargarTodos(),
    versionesStore.getVersiones(),
    programasStore.cargarTodos(),
    indicadoresStore.cargarTodos(),
    indicadorInstrumentoStore.getRelaciones(),
    idUsuario ? evaluadoresStore.cargarMisAsignaciones(idUsuario) : Promise.resolve()
  ])
  cargando.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "header-flex" }, [
      _cache[5] || (_cache[5] = _createElementVNode("div", null, [
        _createElementVNode("h1", null, "Mis Procesos de Autoevaluación"),
        _createElementVNode("p", { class: "subtitulo" }, "Accede a las tareas que te han sido asignadas en cada proceso.")
      ], -1)),
      _createElementVNode("button", {
        class: "btn salir",
        onClick: cambiarModo
      }, "Cambiar modo")
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "filtro-label" }, "Estado:", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filtroEstado).value = $event)),
          class: "select-filtro"
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "Todos", -1)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(opcionesEstado, (e) => {
            return _createElementVNode("option", {
              key: e.value,
              value: e.value
            }, _toDisplayString(e.label), 9, _hoisted_4)
          }), 64))
        ], 512), [
          [_vModelSelect, filtroEstado.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "filtro-label" }, "Buscar:", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((busqueda).value = $event)),
          type: "text",
          class: "input-busqueda",
          placeholder: "Período..."
        }, null, 512), [
          [_vModelText, busqueda.value]
        ])
      ]),
      _createElementVNode("label", {
        class: _normalizeClass(["filtro-toggle", { activo: ocultarFinalizados.value }])
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ocultarFinalizados).value = $event)),
          disabled: filtroEstado.value === 'finalizado'
        }, null, 8, _hoisted_6), [
          [_vModelCheckbox, ocultarFinalizados.value]
        ]),
        _cache[9] || (_cache[9] = _createTextVNode(" Ocultar finalizados "))
      ], 2)
    ]),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Cargando tus procesos..."))
      : (!procesosFiltrados.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No tienes procesos asignados en este momento. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procesosFiltrados.value, (p) => {
              return (_openBlock(), _createElementBlock("div", {
                key: p.id,
                class: _normalizeClass(['proceso-card', cardAbierta.value === p.id ? 'card-activa' : '']),
                onClick: ($event: any) => (toggleCard(p.id!))
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h3", _hoisted_12, _toDisplayString(nombreVersion(p.id_version)), 1),
                  (p.created_at)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(formatFecha(p.created_at)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['badge-tipo', p.ambito === 'institucional' ? 'badge-inst' : 'badge-prog'])
                  }, _toDisplayString(p.ambito === 'institucional' ? 'Institucional' : nombrePrograma(p.id_programa)), 3)
                ]),
                (p.observaciones)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(p.observaciones), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fases, (fase, idx) => {
                    return _createElementVNode("div", {
                      key: fase.value,
                      class: _normalizeClass(['fase-paso', pasoActivo(p.estado, fase.value) ? 'activo' : '', pasoCompletado(p.estado, idx) ? 'completado' : ''])
                    }, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "fase-punto" }, null, -1)),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(fase.label), 1)
                    ], 2)
                  }), 64))
                ]),
                _createVNode(_Transition, { name: "slide-fade" }, {
                  default: _withCtx(() => [
                    (cardAbierta.value === p.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          (!esEspecifica(p) && !esProcesoHistorico(p))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn salir",
                                onClick: _withModifiers(($event: any) => (irAModelo(p.id)), ["stop"])
                              }, " Seguimiento ", 8, _hoisted_19))
                            : _createCommentVNode("", true),
                          (_unref(authStore).tienePermiso('procesos.asignar') && p.ambito === 'programa' && !esProcesoHistorico(p))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn guardar",
                                disabled: !puedeAsignarTareas(p),
                                title: !puedeAsignarTareas(p) ? 'Disponible en fase Ejecución o Evaluación' : '',
                                onClick: _withModifiers(($event: any) => (irAAsignarTareas(p.id)), ["stop"])
                              }, " Asignar tareas ", 8, _hoisted_20))
                            : _createCommentVNode("", true),
                          (p.estado === 'ejecucion' && !esProcesoHistorico(p))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "btn guardar",
                                onClick: _withModifiers(($event: any) => (irAEvidencias(p.id_version, p.id)), ["stop"])
                              }, " Subir Evidencias ", 8, _hoisted_21))
                            : _createCommentVNode("", true),
                          (p.estado === 'evaluacion')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                class: "btn guardar",
                                onClick: _withModifiers(($event: any) => (irACalificar(p.id_version)), ["stop"])
                              }, " Calificar Indicadores ", 8, _hoisted_22))
                            : _createCommentVNode("", true),
                          (_unref(authStore).tienePermiso('calificacion.ver') && p.estado === 'informe' && !esProcesoHistorico(p))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                class: "btn guardar",
                                onClick: _withModifiers(($event: any) => (irAComparativo(p.id)), ["stop"])
                              }, " Comparativo ", 8, _hoisted_23))
                            : _createCommentVNode("", true),
                          (_unref(authStore).tienePermiso('calificacion.ver') && p.estado === 'informe')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 5,
                                class: "btn guardar",
                                onClick: _withModifiers(($event: any) => (irAResultados(p.id)), ["stop"])
                              }, " Resultados ", 8, _hoisted_24))
                            : _createCommentVNode("", true),
                          (_unref(authStore).tienePermiso('informes.ver') && p.estado === 'informe' && !esProcesoHistorico(p))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 6,
                                class: "btn guardar",
                                onClick: _withModifiers(($event: any) => (irAInforme(p.id)), ["stop"])
                              }, " Informe ", 8, _hoisted_25))
                            : _createCommentVNode("", true),
                          (_unref(authStore).tienePermiso('planes.ver') && !esProcesoHistorico(p))
                            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                key: 7,
                                class: "btn guardar",
                                disabled: !puedeVerPlan(p),
                                title: !puedeVerPlan(p) ? 'Disponible en fase Informe o Finalizado' : '',
                                onClick: _withModifiers(($event: any) => (irAPlanMejoramiento(p.id)), ["stop"])
                              }, " Plan de mejoramiento ", 8, _hoisted_26)), [
                                [_vShow, puedeVerPlan(p) || _unref(authStore).esAdmin]
                              ])
                            : _createCommentVNode("", true),
                          (_unref(authStore).tienePermiso('informes.ver') && esProcesoHistorico(p) && ['informe', 'finalizado'].includes(p.estado ?? ''))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 8,
                                class: "btn guardar",
                                onClick: _withModifiers(($event: any) => (abrirAdjuntarInformes(p)), ["stop"])
                              }, " Adjuntar Informes ", 8, _hoisted_27))
                            : _createCommentVNode("", true),
                          (!esEspecifica(p) && p.estado !== 'finalizado' && _unref(authStore).tienePermiso('procesos.avanzar'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 9,
                                class: _normalizeClass(['btn', p.estado === 'informe' ? 'finalizar' : 'avanzar']),
                                disabled: avanzandoId.value === p.id,
                                onClick: _withModifiers(($event: any) => (avanzarProceso(p)), ["stop"])
                              }, _toDisplayString(avanzandoId.value === p.id ? 'Procesando…' : labelAvanzar(p.estado)), 11, _hoisted_28))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ], 10, _hoisted_10))
            }), 128))
          ])),
    _createVNode(AdjuntarInformesModal, {
      visible: adjuntarVisible.value,
      idEjecucion: adjuntarIdEjecucion.value,
      periodo: adjuntarPeriodo.value,
      onCerrar: _cache[3] || (_cache[3] = ($event: any) => (adjuntarVisible.value = false)),
      onSubido: alSubirInformes
    }, null, 8, ["visible", "idEjecucion", "periodo"]),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[4] || (_cache[4] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})